export function formatLockDuration(seconds: number): string {
  const MINUTE = 60;
  const HOUR = 3600;
  const DAY = 86400;

  if (seconds >= DAY) return `${Math.ceil(seconds / DAY)}d`;
  if (seconds >= HOUR) return `${Math.ceil(seconds / HOUR)}h`;
  if (seconds >= MINUTE) return `${Math.ceil(seconds / MINUTE)}min`;
  return `${seconds}sec`;
}
